import { FC } from 'react';
import { Button, FormSelect } from 'components/common';
import { ISelectOption } from 'components/common/Select/types';
import { defaultSelectOptionFormatter } from 'pages/ProductsPage/ProductsTable/ProductsToolbar/helpers';
import { FormProvider, useForm } from 'react-hook-form';
import { FormattedMessage, useIntl } from 'react-intl';
import { useSearchParams } from 'react-router-dom';
import { loanQuestions } from './questions';
import { IAddStudentLoanProps, IStudentLoanForm } from './types';
import { v4 as uuidv4 } from 'uuid';
import { IStudentLoan } from '../StudentLoansWrapper/types';
import { FormNumberField } from 'components/common/FormNumberField';

export const AddStudentLoan: FC<IAddStudentLoanProps> = ({ onGoBack, onSubmitStudentLoan, studentLoanToEdit }) => {
  const intl = useIntl();
  const [searchParams] = useSearchParams();
  const formApplicantNames = searchParams.get('applicantNames')?.split(',') || [];
  const isJointApplication = formApplicantNames.length > 1;
  const requiredFieldErrorMessage = intl.formatMessage({ id: 'common.error.requiredField' });

  const form = useForm<IStudentLoanForm>({
    defaultValues: {
      monthlyPayment: studentLoanToEdit?.monthlyPayment || '',
      borrower: studentLoanToEdit?.borrower || null,
    },
  });

  const submitFormHandler = (studentLoanForm: IStudentLoanForm) => {
    const studentLoan: IStudentLoan = {
      id: studentLoanToEdit?.id || uuidv4(),
      monthlyPayment: studentLoanForm?.monthlyPayment || 0,
      borrower: studentLoanForm?.borrower || formApplicantNames[0],
    };
    onSubmitStudentLoan(studentLoan);
  };

  const formState = form.watch();

  return (
    <FormProvider {...form}>
      <form onSubmit={form.handleSubmit(submitFormHandler)}>
        {isJointApplication && (
          <div>
            <FormattedMessage id={loanQuestions.borrower.labelKey} tagName={'h4'} />
            <FormSelect
              name={'borrower'}
              rules={{ required: isJointApplication }}
              options={formApplicantNames.map(defaultSelectOptionFormatter)}
              selectProps={{
                isOptionEqualToValue: (option: ISelectOption, selectedOptionValue: string) =>
                  option.value === selectedOptionValue,
                value: formState.borrower,
              }}
              selectInputProps={{ placeholder: intl.formatMessage({ id: 'placeholders.select' }) }}
              className={'w-full'}
            />
          </div>
        )}

        <div>
          <FormattedMessage id={loanQuestions.monthlyPayment.labelKey} tagName={'h4'} />
          <FormNumberField name={'monthlyPayment'} rules={{ required: requiredFieldErrorMessage, min: 0 }} />
        </div>

        <div className={'mt-8 flex justify-between'}>
          <Button variant={'outlined'} onClick={onGoBack}>
            <FormattedMessage id={'cta.back'} />
          </Button>

          <Button variant={'contained'} type={'submit'} disabled={!form.formState.isDirty}>
            <FormattedMessage id={'cta.continue'} />
          </Button>
        </div>
      </form>
    </FormProvider>
  );
};
